export default "__VITE_ASSET__5ac0ec96__"